import RoundButton from "features/shared/components/buttons/RoundButton";
import React from "react";
import { useTranslation } from "react-i18next";
import AccountRestrictionDTO from "../dtos/AccountRestrictionDTO";

interface Props {
  restriction: AccountRestrictionDTO;
  onEditClick?: (restriction: AccountRestrictionDTO) => void;
  onDeleteClick?: (restriction: AccountRestrictionDTO) => void;
}

const AccountRestriction = ({
  restriction,
  onEditClick,
  onDeleteClick,
}: Props) => {
  // tranlations
  const { t } = useTranslation("accounts\\enums\\accountRestrictionType");

  // helpers
  const getRestrictionEntity = () => {
    switch (restriction.entity) {
      case "ContractualAccount":
        return restriction.contractualAccountNumber;
      case "PlaceOfDelivery":
        return restriction.placeOfDeliveryIdentification;
      default:
        return "";
    }
  };

  // render
  return (
    <div className="row no-gutters align-items-center">
      <div className="col">
        {t(restriction.entity!)}
        <div className="text-muted small">{getRestrictionEntity()}</div>
      </div>
      <div className="col-auto pl-3">
        {onEditClick !== undefined && (
          <RoundButton
            icon="pen"
            className="mr-1"
            onClickHandler={() => onEditClick(restriction)}
          />
        )}
        {onDeleteClick !== undefined && (
          <RoundButton
            icon="trash"
            onClickHandler={() => onDeleteClick(restriction)}
          />
        )}
      </div>
    </div>
  );
};

export default AccountRestriction;
